import { ChordLyricsPair } from "chordsheetjs";

/**
 * Merge consecutive ChordLyricsPairs where one has a chord and the next has no chord.
 *
 * chordsheetjs splits at word boundaries, creating pairs like:
 *   - "[A] o" -> { chords: "A", lyrics: " " } + { chords: "", lyrics: "o" }
 *   - "[F#m]u so" -> { chords: "F#m", lyrics: "u " } + { chords: "", lyrics: "so" }
 *
 * This function merges consecutive lyrics-only pairs back into their preceding chord pair.
 */
export function mergeChordLyricsPairs(
  pairs: ChordLyricsPair[],
): ChordLyricsPair[] {
  const result: ChordLyricsPair[] = [];

  for (let i = 0; i < pairs.length; i++) {
    const current = pairs[i];
    if (!current) continue;

    // If current has a chord, collect all following lyrics-only pairs
    if (current.chords) {
      let mergedLyrics = current.lyrics || "";

      // Keep merging while next pair has no chord
      while (i + 1 < pairs.length) {
        const nextPair = pairs[i + 1];
        if (!nextPair || nextPair.chords) break;
        i++;
        mergedLyrics += nextPair.lyrics || "";
      }

      // Create a new ChordLyricsPair with merged lyrics
      const merged = new ChordLyricsPair();
      merged.chords = current.chords;
      merged.lyrics = mergedLyrics;
      result.push(merged);
    } else {
      // Lyrics-only pair at the start (no preceding chord to merge into)
      result.push(current);
    }
  }

  return result;
}
